import React from "react";
import PropTypes from "prop-types";
import "../../../NonRKPayInvoiceDetail.scss";

const ActionsList = ({ actions, ButtonComponent }) => (
    <>
        {actions
            .filter(({ condition }) => condition)
            .map(({ id, className, label, onClick, disabled, iconClass, title, loading, dataTestId }) => (
                <li key={id}>
                    <ButtonComponent
                        id={id}
                        className={className}
                        onClick={onClick}
                        disabled={disabled}
                        iconClass={iconClass}
                        label={label}
                        title={title}
                        loading={loading}
                        dataTestId={dataTestId}
                    />
                </li>
            ))}
    </>
);

ActionsList.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func,
            condition: PropTypes.bool.isRequired,
            disabled: PropTypes.bool,
            iconClass: PropTypes.string,
            title: PropTypes.string,
            className: PropTypes.string,
            loading: PropTypes.bool,
            dataTestId: PropTypes.string,
        })
    ).isRequired,
    ButtonComponent: PropTypes.elementType.isRequired,
};

export default ActionsList;
